import * as React from 'react';
import { Link } from 'react-router';
import { rem } from 'polished';
import styled from 'styled-components';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { SanitasFooterRowWrapper as FooterRowWrapper } from './FooterRowWrapper';

interface Props {
  withoutSitemapLink?: boolean;
  leftText: string;
}

function FooterLastRow({ leftText }: Props) {
  return (
    <FooterRowWrapper>
      <CopyrightWrapper>
        <SmallTextP>{leftText}</SmallTextP>
      </CopyrightWrapper>
      <SmallTextA rel="noreferrer" href="https://www.bart.sk/" target="_blank">
        {'Vytvoril bart.sk - Tvoríme digitálne zážitky'}
      </SmallTextA>
    </FooterRowWrapper>
  );
}

const SmallTextA = styled.a`
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
  line-height: ${rem(18)};
  text-decoration: none;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
`;
const CopyrightWrapper = styled(FlexRowCenterVertical)`
  justify-content: flex-start;
  margin-right: ${rem(16)};

  ${({ theme }) => theme.mediab.l925`
      margin-bottom: ${rem(8)};
      margin-right: 0;
  `};
`;

const SmallTextP = styled(TextP)`
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
  line-height: ${rem(18)};

  ${({ theme }) => theme.mediab.m580`
    text-align: center;
  `}
`;

function areEqual(prev: Props, next: Props) {
  return (
    prev.leftText === next.leftText &&
    prev.withoutSitemapLink === next.withoutSitemapLink
  );
}
const MemoizedFooterLastRow = React.memo(FooterLastRow, areEqual);
export { MemoizedFooterLastRow as SanitasFooterLastRow };
